<template>
    <div class="params">
        <div
            v-for="(log,key) in logs"
            :key="key"
        >
            <div>
                <p>{{key}}:</p>
                <pre v-if="typeof(log) === 'string' && log.indexOf('{') > -1 ">{{ JSON.parse(log) }}</pre>
                <pre v-else>{{ log }}</pre>
            </div>
        </div>

    </div>
</template>
<script>

export default {
    name: "TaskModalLogs",
    props: ['logs']
}
</script>
<style lang="scss" scoped>
.params{
    width: 100%;
    text-align: left;
    padding: 10px;
    textarea{
        width: 100%;
        height: 100%;
    }
  pre{
    text-align: left;
  }
}

</style>
